import { render, staticRenderFns } from "./xuanzeImg.vue?vue&type=template&id=77277ced&scoped=true&"
import script from "./xuanzeImg.vue?vue&type=script&lang=js&"
export * from "./xuanzeImg.vue?vue&type=script&lang=js&"
import style0 from "./xuanzeImg.vue?vue&type=style&index=0&id=77277ced&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77277ced",
  null
  
)

export default component.exports